<template>
  <div class="card">
    <div class="card-header">最新餐廳</div>
    <div class="card-body">
      <div v-for="restaurant in restaurants" :key="restaurant.id">
        <h4>
          <router-link
            :to="{ name: 'restaurant', params: { id: restaurant.id } }"
            >{{ restaurant.name }}</router-link
          >
          <small>{{ restaurant.Category.name }}</small>
        </h4>
        <p>
          {{ restaurant.description }}
        </p>
        {{ restaurant.createdAt | fromNow }}
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import { fromNowFilter } from "../utils/fromNow";

export default {
  props: {
    restaurants: {
      type: Array,
      required: true,
    },
  },
  mixins: [fromNowFilter],
};
</script>

<style scoped>
small {
  font-size: 10px;
}
</style>